import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, isRef as _isRef, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1378e727"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "cs-form",
  "data-height": "md"
}
const _hoisted_2 = ["onKeypress"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-br-cross cs-font-s-tiny" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-br-search" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]


import { defineComponent, watch, ref, defineEmits } from "vue";
import { toast } from "vue3-toastify";

const __default__ = defineComponent({
  name: "InputSearch",
  props: {
    keyword: {
      type: String,
      required: false,
    },
  },
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["onSearch", "onCancel"],
  setup(__props, { emit }) {



let isSearch = ref(false);
let lkeyword = ref("");

const kw = ref("");

watch(kw, (newKeyworkd, oldKeyworkd) => {
  lkeyword.value = "" + newKeyworkd;
});

const onSearch = () => {
  if (2 <= lkeyword.value.length) {
    isSearch.value = true;
    emit("onSearch", lkeyword.value);
  } else if (1 === lkeyword.value.length) {
    toast.warn("2자 이상 입력해주세요.", { transition: toast.TRANSITIONS.SLIDE, position: toast.POSITION.TOP_CENTER });
  } else {
    onCancel();
  }
};

const onCancel = () => {
  lkeyword.value = "";
  isSearch.value = false;
  emit("onCancel", null);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["cs-search", { searchbar: _unref(isSearch) }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "left-item"),
      _withDirectives(_createElementVNode("input", {
        class: "",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(lkeyword) ? (lkeyword).value = $event : lkeyword = $event)),
        onKeypress: _withKeys(_withModifiers(onSearch, ["stop"]), ["enter"]),
        placeholder: "검색어를 입력해주세요."
      }, null, 40, _hoisted_2), [
        [_vModelText, _unref(lkeyword)]
      ]),
      (_unref(isSearch))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "cs-btn cs-btn-clear ml-1 p-1 text-lg btn-search",
            onClick: onCancel
          }, _hoisted_4))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "cs-btn cs-btn-clear ml-1 p-1 text-lg btn-search",
            onClick: onSearch
          }, _hoisted_6))
    ])
  ], 2))
}
}

})